import { __assign, __rest } from "tslib";
import React from 'react';
import { Box } from '@material-ui/core';
export var FlexBox = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ display: "flex", width: "100%" }, other), children));
};
//# sourceMappingURL=FlexBox.js.map